import { scrollToTop } from 'common/utils';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';

type HandleSourcingSharedSetupApplicationBackControllerProps = {
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedSetupApplicationBackController = ({
  set
}: HandleSourcingSharedSetupApplicationBackControllerProps) => {
  scrollToTop();
  set({
    step: 'JOB_INFORMATION'
  });
};
